import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { viewImage } from '../../CommonUtils/viewImage';
import allowNumbersOnly, { handlePaste } from '../../CommonUtils/CommonValidations';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { useSelector } from 'react-redux';
import { FaEye } from 'react-icons/fa';
export default function AfflFfcaCommittePhoto() {
    const userId = sessionStorage.getItem('user_id');
    const ffcaUserId = userId.split('ffca_')[1]
    const acYear = sessionStorage.getItem('ac_year');
    const collCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const result = userId.startsWith("ffca") ? ffcaUserId : collCode;
    const Collegetype = sessionStorage.getItem('loginType'); // "college" or "ffca" or "university"
    const AfflCommittevalidation = Yup.object({
        noOfClsRoomsAvailability: Yup.string().required(ERROR_MSG).nullable(),
        noOfClsRoomsAvailabilityAcc: Yup.string().required(ERROR_MSG).nullable(),
        noOfClsRoomsAvailabilityRcc: Yup.string().required(ERROR_MSG).nullable(),
        noOfClsRoomsAvailabilityWithoutProFurnitureVent: Yup.string().required(ERROR_MSG).nullable(),
    })
    const AfflCommittePhotoFormik = useFormik({
        initialValues: {
            tmcPhoto1: '',
            tmcPhoto2: '',
            tmcPhoto3: '',
            tmcPhoto4: '',
            tmcPhoto5: '',
            tmcPhoto6: '',
            tmcPhoto7: '',
            tmcPhoto8: '',
            tmcPhoto9: '',
            tmcPhoto10: '',
            noOfClsRoomsAvailability: "",
            noOfClsRoomsAvailabilityAcc: "",
            noOfClsRoomsAvailabilityRcc: "",
            noOfClsRoomsAvailabilityWithoutProFurnitureVent: "",
        },
        validationSchema: AfflCommittevalidation,
        onSubmit: async (values) => {
            const valuestosend = {
                ...values,
                noOfClsRoomsAvailability: parseInt(values.noOfClsRoomsAvailability || ""),
                noOfClsRoomsAvailabilityAcc: parseInt(values.noOfClsRoomsAvailabilityAcc || ""),
                noOfClsRoomsAvailabilityRcc: parseInt(values.noOfClsRoomsAvailabilityRcc || ""),
                noOfClsRoomsAvailabilityWithoutProFurnitureVent: parseInt(values.noOfClsRoomsAvailabilityWithoutProFurnitureVent || ""),
            };

            const updatedValues = { ...values };

            // Update values for photos
            for (let index = 1; index <= 10; index++) {
                const fieldName = `tmcPhoto${index}`;
                const photoKey = `tmc_photo_${index}`;

                if (values[fieldName]) {
                    updatedValues[fieldName] = values[fieldName];
                } else if (initialFfcaPhoto && initialFfcaPhoto[photoKey]) {
                    updatedValues[fieldName] = initialFfcaPhoto[photoKey];
                }
            }

            // Find missing photos
            let missingPhotos = [];
            for (let index = 1; index <= 10; index++) {
                const fieldName = `tmcPhoto${index}`;
                const photoKey = `tmc_photo_${index}`;
                const isPhotoAvailable = FfcaPhoto[photoKey];

                if (!isPhotoAvailable && !values[fieldName]) {
                    missingPhotos.push(index);
                }
            }

            // Show alert for missing photo
            const showMissingPhotoAlert = (index) => {
                let errorMessage = '';
                switch (index) {
                    case 1: errorMessage = 'Please Upload FFCA Photo at College Building'; break;
                    case 2: errorMessage = 'Please Upload FFCA Photo at college classrooms-1'; break;
                    case 3: errorMessage = 'Please Upload FFCA Photo at college classrooms-2'; break;
                    case 4: errorMessage = 'Please Upload FFCA Photo at college classrooms-3'; break;
                    case 5: errorMessage = 'Please Upload FFCA Photo at college classrooms-4'; break;
                    case 6: errorMessage = 'Please Upload FFCA Photo at college labs-1'; break;
                    case 7: errorMessage = 'Please Upload FFCA Photo at college labs-2'; break;
                    case 8: errorMessage = 'Please Upload FFCA Photo at college labs-3'; break;
                    case 9: errorMessage = 'Please Upload FFCA Photo at college labs-4'; break;
                    case 10: errorMessage = 'Please Upload FFCA Photo at college labs-5'; break;
                    default: errorMessage = 'Please Upload FFCA Photo at College'; break;
                }

                return Swal.fire({
                    text: errorMessage,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    backdrop: false,
                });
            };

            // Sequential alerts for missing photos
            const handleSequentialAlerts = async (photosToCheck) => {
                for (const index of photosToCheck) {
                    await showMissingPhotoAlert(index);
                    // Check if the photo is available
                    if (FfcaPhoto[`tmc_photo_${index}`] || values[`tmcPhoto${index}`]) {
                        continue;
                    } else {
                        break;
                    }
                }

                // After checking all, ensure all photos are available
                if (photosToCheck.every(index => FfcaPhoto[`tmc_photo_${index}`] || values[`tmcPhoto${index}`])) {
                    return true;
                } else {
                    console.log('Missing required fields, submission stopped');
                    return false;
                }
            };
            // Check if there are missing photos and handle sequential alerts
            if (missingPhotos?.length > 0) {
                const proceedWithSubmission = await handleSequentialAlerts(missingPhotos);
                if (!proceedWithSubmission) return;
            }

            // Confirm before submitting
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveOamdcFfcaPhotos`;
                    CommonAxiosPost(url, updatedValues).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetCommiteePhotos();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }

    })
    const [initialFfcaPhoto, setInitialFfcaPhoto] = useState(null);
    const [FfcaPhoto, setFfcaPhoto] = useState([]);
    function GetCommiteePhotos() {
        let url = config.url.API_URL + `getOamdcffcaPhotos/${result}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setFfcaPhoto(res?.data?.getOamdcffcaPhotos[0]);
                setInitialFfcaPhoto(res?.data?.getOamdcffcaPhotos[0]);
                const photoFields = [
                    'tmcPhoto1', 'tmcPhoto2', 'tmcPhoto3', 'tmcPhoto4',
                    'tmcPhoto5', 'tmcPhoto6', 'tmcPhoto7', 'tmcPhoto8',
                    'tmcPhoto9', 'tmcPhoto10'
                ];
                photoFields.forEach((fieldName, index) => {
                    const photoKey = `tmc_photo_${index + 1}`;
                    if (FfcaPhoto[photoKey]) {
                        AfflCommittePhotoFormik.setFieldValue(fieldName, FfcaPhoto[photoKey]);
                    } else {
                        AfflCommittePhotoFormik.setFieldValue(fieldName, '');
                    }
                });
            } else {
                setFfcaPhoto([]);
            }
        })
    }
    function GetOamdcRemarks() {
        let url = config.url.API_URL + `getOamdcffcaRemarks/${result}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                AfflCommittePhotoFormik?.setFieldValue("noOfClsRoomsAvailability", res?.data?.getOamdcffcaRemarks[0]?.no_of_cls_rooms_availability);
                AfflCommittePhotoFormik?.setFieldValue("noOfClsRoomsAvailabilityAcc", res?.data?.getOamdcffcaRemarks[0]?.no_of_cls_rooms_availability_acc);
                AfflCommittePhotoFormik?.setFieldValue("noOfClsRoomsAvailabilityRcc", res?.data?.getOamdcffcaRemarks[0]?.no_of_cls_rooms_availability_rcc);
                AfflCommittePhotoFormik?.setFieldValue("noOfClsRoomsAvailabilityWithoutProFurnitureVent", res?.data?.getOamdcffcaRemarks[0]?.no_of_cls_rooms_availability_without_pro_furniture_vent);
            } else {
                console.log("Data Not Found")
            }
        })
    }
    useEffect(() => {
        GetCommiteePhotos();
        GetOamdcRemarks();
    }, [])
    const isUserIdValid = userId && userId.startsWith('ffca');
    return (
        <>
            <CommonFormHeading heading="FFCA Photo at college" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AfflCommittePhotoFormik}>

                        <bie.Row className="px-2 pt-3 mb-3">
                            <bie.Alert variant='danger' className='affl-alert'>
                                <p className='mb-0'>Note:   In All Photos FFCA Committee members should be available(College Building,Class Rooms,Labs)</p>
                            </bie.Alert>

                            <Form onChange={AfflCommittePhotoFormik.handleChange} onSubmit={AfflCommittePhotoFormik.handleSubmit} className='affl-form'>
                                {isUserIdValid && (<>
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 className="mb-0">Inspection Remarks</h1></div>
                                    <bie.Row className='px-2 my-3'>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2 mt-2'>
                                            <label className='mb-1 field-mandatory'>Number of Class Rooms available as per FFCA</label>
                                            <Field type='text' name="noOfClsRoomsAvailability" maxLength={8} className='form-control  mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noOfClsRoomsAvailability" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory'>Number of Class Rooms available (ACC) as Per FFCA</label>
                                            <Field type='text' name="noOfClsRoomsAvailabilityAcc" className='form-control mb-2' maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noOfClsRoomsAvailabilityAcc" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory' > Number of Class Rooms available (RCC) as Per FFCA</label>
                                            <Field type='text' name="noOfClsRoomsAvailabilityRcc" className='form-control' maxLength={8} onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noOfClsRoomsAvailabilityRcc" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                            <label className='mb-1 field-mandatory'>Number of Class Rooms without Proper Furniture /Ventilation</label>
                                            <Field type='text' name="noOfClsRoomsAvailabilityWithoutProFurnitureVent" maxLength={8} className='form-control mb-2' onKeyPress={(e) => { allowNumbersOnly(e); }} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="noOfClsRoomsAvailabilityWithoutProFurnitureVent" component="div" className="text-error" />
                                        </bie.Col>
                                    </bie.Row>
                                </>)}
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="mb-0">FFCA Photo at college</h1></div>
                                <div className="table-responsive">
                                    {isUserIdValid ? (<>
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr><th>S.No</th><th>Discription</th><th>Upload </th></tr>
                                            </thead>
                                            <tbody >
                                                {['FFCA Photo at College Building', 'FFCA Photo at Class Rooms', 'FFCA Photo at Class Rooms', 'FFCA Photo at Class Rooms', 'FFCA Photo at Class Rooms', 'FFCA Photo at Labs', 'FFCA Photo at Labs', 'FFCA Photo at Labs', 'FFCA Photo at Labs', 'FFCA Photo at Labs'].map((description, index) => (
                                                    <tr key={index}>
                                                        <td className='cen'>{index + 1}</td>
                                                        <td className='text-left'>{description}</td>
                                                        <td>
                                                            <bie.Row className='align-items-center'>
                                                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                                                    <input type="file" className="form-control" name={`tmcPhoto${index + 1}`} accept='image/*'
                                                                        onChange={(e) => {
                                                                            let fileVal = `${userId}_${acYear}`;
                                                                            let filename = `${fileVal}tmcPhoto${index + 1}`;
                                                                            let path = "/Uploads/LinksUploads/2024/";
                                                                            ImagePdfBucket(e, AfflCommittePhotoFormik, path, `tmcPhoto${index + 1}`, filename, "image");
                                                                        }} />
                                                                </bie.Col>


                                                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                                                    {FfcaPhoto && FfcaPhoto[`tmc_photo_${index + 1}`] && (
                                                                        <button type='button'
                                                                            onClick={() => {
                                                                                const photoPath = FfcaPhoto[`tmc_photo_${index + 1}`];
                                                                                viewImage(photoPath);
                                                                            }} className="btn btn-primary">
                                                                            <FaEye size={20} />
                                                                        </button>
                                                                    )}
                                                                </bie.Col>
                                                            </bie.Row>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>

                                    ) : (
                                        <>
                                            {Collegetype === "university" ? (<>

                                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                                    <thead>
                                                        <tr>
                                                            <th className='cen'>S.No</th>
                                                            <th>Discription</th>
                                                            <th>Upload </th>
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        {['FFCA Photo at College Building', 'FFCA Photo at Class Rooms', 'FFCA Photo at Class Rooms', 'FFCA Photo at Class Rooms', 'FFCA Photo at Class Rooms', 'FFCA Photo at Labs', 'FFCA Photo at Labs', 'FFCA Photo at Labs', 'FFCA Photo at Labs', 'FFCA Photo at Labs'].map((description, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td className='text-left'>{description}</td>

                                                                <td className='cen'>
                                                                    <bie.Row>
                                                                        <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'></bie.Col>
                                                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                                                        </bie.Col>
                                                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-6'>
                                                                            {FfcaPhoto && FfcaPhoto[`tmc_photo_${index + 1}`] && (
                                                                                <button type='button'
                                                                                    onClick={() => {
                                                                                        const photoPath = FfcaPhoto[`tmc_photo_${index + 1}`];
                                                                                        viewImage(photoPath);
                                                                                    }} className="btn btn-primary">
                                                                                    <FaEye />
                                                                                </button>
                                                                            )}
                                                                        </bie.Col>
                                                                    </bie.Row>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </>) : (<></>)}


                                        </>
                                    )}
                                </div>
                                {isUserIdValid && (<>
                                    <div className="pt-1 mb-5">

                                        <button type="submit" className="btn btn-success btn-sm float-end">
                                            Submit
                                        </button>

                                    </div>
                                </>)}
                            </Form>
                        </bie.Row>
                    </FormikProvider>
                </bie.Container >
            </bie.Container >
        </>)
}
